import type { KyInstance } from 'ky';

import { ensureError } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { ReorderSavedFiltersRequest } from './types/reorder-saved-filters-request.type';
import type { SavedFilter } from './types/saved-filter.type';

/**
 * Persists a new drag-determined order for the user's saved filters in a
 * single source. Server writes `sort_order` to each row's index in `orderedIds`.
 *
 * @param instance - Ky HTTP instance from the application store.
 * @param body - Source and the full ordered id list.
 * @returns OperationResultWithData wrapping the updated `SavedFilter[]`.
 */
export const reorderSavedFilters = async (instance: KyInstance, body: ReorderSavedFiltersRequest) => {
  try {
    return await instance
      .post<OperationResultWithData<SavedFilter[]>>(Uri.savedFilters.reorder, {
        json: body,
      })
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
